import { gql } from '@apollo/client';

// ********************************************
//                   FRAGMENTS
// ********************************************
export const AttributeValueFragment = gql`
  fragment CommonAttributeValueFields on AbstractAttributeValue {
    attributeId
    name
    ownerOrganizationId
    type
    attributeValueId
    entityIdentifier
    entityDomain
    effectiveFromReportingDate
    displayName
  }

  fragment AttributeValueFragment on AttributeValue {
    __typename

    ...CommonAttributeValueFields

    ... on StringAttributeValue {
      stringValue: value
      stringValidation: validation {
        type
        allowedValues
      }
    }

    ... on FloatAttributeValue {
      floatValue: value
      floatValidation: validation {
        type
        display {
          ... on AttributeValueCurrencyDisplay {
            displayType
            currencyCode
          }
        }
      }
    }

    ... on IntegerAttributeValue {
      integerValue: value
      integerValidation: validation {
        type
      }
    }

    ... on BooleanAttributeValue {
      booleanValue: value
      booleanValidation: validation {
        type
      }
    }

    ... on PercentageRateAttributeValue {
      percentageRateValue: value
      percentageRateValidation: validation {
        type
      }
    }

    ... on FullDateStrAttributeValue {
      fullDateStrValue: value
      fullDateStrValidation: validation {
        type
      }
    }

    ... on StringArrayAttributeValue {
      stringArrayValue: value
      stringArrayValidation: validation {
        type
        allowedValues
      }
    }
  }
`;
export const AttributeFragment = gql`
  fragment AttributeFragment on Attribute {
    attributeId
    displayName
    type
    validation {
      type
      allowedValues
      display {
        ... on AttributeValueCurrencyDisplay {
          displayType
          currencyCode
        }
      }
    }
    attributeValue {
      ...AttributeValueFragment
    }
    attributeValues {
      ...AttributeValueFragment
    }
  }
  ${AttributeValueFragment}
`;

// ********************************************
//                   QUERIES
// ********************************************

export const GET_ATTRIBUTE_LIST_BY_ENTITY = gql`
  query GetAttributeListByEntity(
    $organizationId: UUID!
    $listName: String!
    $entityDomain: AttributeEntityDomain!
    $entityIdentifier: UUID
  ) {
    attributes: getAttributeListByEntity(
      organizationId: $organizationId
      listName: $listName
      entityDomain: $entityDomain
      entityIdentifier: $entityIdentifier
    ) {
      ...AttributeFragment
    }
  }
  ${AttributeFragment}
`;

// ********************************************
//                   MUTATIONS
// ********************************************

export const CREATE_OR_UPDATE_LATEST_ATTRIBUTE_VALUE = gql`
  mutation CreateOrUpdateLatestAttributeValue(
    $input: CreateOrUpdateLatestAttributeValueInput!
  ) {
    createOrUpdateLatestAttributeValue(input: $input) {
      response
    }
  }
`;
